// Valid MTO options
export const VALID_MTOS = [
  'Ecobank Transfer',
  'Access Money Express',
  'MTN Mobile Money',
  'M-Pesa',
] as const

export type ValidMTO = (typeof VALID_MTOS)[number]

// Transaction ID generation based on MTO
export const generateTransactionId = (mto: string, index: number): string => {
  const paddedIndex = (index + 1).toString().padStart(8, '0')

  if (mto.includes('Access')) {
    return `EXP${paddedIndex}`
  } else if (mto.includes('Ecobank')) {
    return `ECO${paddedIndex}`
  } else if (mto.includes('MTN')) {
    return `MTN${paddedIndex}`
  } else if (mto.includes('M-Pesa')) {
    // Format: 80{7-digit number}
    const sevenDigit = (index + 1).toString().padStart(7, '0')
    return `80${sevenDigit}`
  } else {
    // Default format
    return `TXN${(index + 1).toString().padStart(12, '0')}`
  }
}

// Detect which MTOs a transaction ID could belong to
export const detectMTOsFromTransactionId = (txnId: string): string[] => {
  const possibleMTOs: string[] = []

  // Check Access format: EXP{8-digit}
  if (/^EXP\d{8}$/.test(txnId)) {
    possibleMTOs.push('Access Money Express')
  }

  // Check Ecobank format: ECO{8-digit}
  if (/^ECO\d{8}$/.test(txnId)) {
    possibleMTOs.push('Ecobank Transfer')
  }

  // Check MTN format: MTN{8-digit}
  if (/^MTN\d{8}$/.test(txnId)) {
    possibleMTOs.push('MTN Mobile Money')
  }

  // Check M-Pesa format: 80{7-digit}
  if (/^80\d{7}$/.test(txnId)) {
    possibleMTOs.push('M-Pesa')
  }

  // Check default format: TXN{12-digit}
  if (/^TXN\d{12}$/.test(txnId)) {
    possibleMTOs.push('Ecobank Transfer')
    possibleMTOs.push('Access Money Express')
  }

  return possibleMTOs
}

// Transaction stages
export const TRANSACTION_STAGES = [
  'Screening',
  'Compliance Check',
  'Verification',
  'Processing',
  'Finalization',
] as const

// Transaction lifecycle states
export const TRANSACTION_LIFECYCLES = [
  'IN PROGRESS',
  'COMPLETED',
  'FAILED',
  'CANCELLED',
] as const

// Transaction statuses (business outcome)
export const TRANSACTION_STATUSES = [
  'FUNDS TRANSFERRED',
  'PENDING TRANSFER',
  'TRANSFER FAILED',
  'CANCELLED',
  'AWAITING APPROVAL',
] as const

// System statuses (operational status)
export const SYSTEM_STATUSES = [
  'IN PROGRESS',
  'COMPLETED',
  'FAILED',
  'CANCELLED',
  'PENDING',
] as const
